// Main Scripts
// ---------------------
import ticketButton from './js/widgets/ticketButton.js';
import mainSlideshow from './js/widgets/mainSlideshow.js';
import circleCards from './js/widgets/circleCards.js';
import scrollerSponsors from './js/widgets/scrollerSponsors.js';

// Secondary Scripts
// --------------------
import './js/localjs.js';

$(document).ready(function () {
  ticketButton();

  if (window.location.pathname === '/') {
    mainSlideshow();
    circleCards();
    scrollerSponsors();
  }
});
